import { render } from "./MenuLateralDashSmall.vue?vue&type=template&id=433f7769&scoped=true"
import script from "./MenuLateralDashSmall.vue?vue&type=script&lang=js"
export * from "./MenuLateralDashSmall.vue?vue&type=script&lang=js"

import "./MenuLateralDashSmall.vue?vue&type=style&index=0&id=433f7769&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-433f7769"]])

export default __exports__